export default __webpack_public_path__ + "static/media/primary.04ad24dbd013b6c8b9196e314ceaa3bc.svg";